import './Map.css';

const Mapp = ()=>{
    return(
    <div className='container-fluid map'>
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3405.079267739554!2d73.11448757596837!3d31.41194205249045!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3922698c61c549b9%3A0x5e3c620912ef39a3!2sASDEV!5e0!3m2!1sen!2s!4v1683114300029!5m2!1sen!2s" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>
    )
}

export default Mapp;